var c = /* @__PURE__ */ ((o) => (o[o.EmailLogin = 0] = "EmailLogin", o[o.SelectWallet = 1] = "SelectWallet", o[o.WalletLogin = 2] = "WalletLogin", o[o.Signup = 3] = "Signup", o[o.Consent = 4] = "Consent", o))(c || {});
const r = 60, s = 4;
var l = /* @__PURE__ */ ((o) => (o.Localhost = "localhost", o))(l || {});
const n = "http://localhost:3011";
export {
  s as ACCOUNT_TAG_PADDING,
  l as HostName,
  n as LocalSsoUrl,
  c as LoginSlideState,
  r as RoninQrcodeRefresh
};
//# sourceMappingURL=login.js.map
